import React, { ChangeEvent, forwardRef } from 'react';

import MUITabs, { TabsProps as MUITabsProps } from '@material-ui/core/Tabs';

/**
 * https://github.com/mui-org/material-ui/issues/17454
 */
export interface TabsProps extends Omit<MUITabsProps, 'onChange'> {
  onChange?: (event: ChangeEvent<{}>, value: any) => void;
}

const Tabs = forwardRef<HTMLButtonElement, TabsProps>((props, ref) => {
  const {
    children,
    indicatorColor = 'primary',
    onFocusVisible,
    textColor = 'primary',
    ...restProps
  } = props;

  return (
    <MUITabs
      {...restProps}
      ref={ref}
      indicatorColor={indicatorColor}
      textColor={textColor}
    >
      {children}
    </MUITabs>
  );
});

Tabs.displayName = 'Tabs';

export default Tabs;
